export const CONTEXT_VERSION = 1;

export const EVENT = {
	CONNECTION: {
		ESTABLISH: 'connection:establish',
		RECONNECT: 'connection:reconnect'
	},
	CHANNEL: {
		FOLLOW_CHANGE: 'channel:follow-change',
		SUBSCRIBE_CHANGE: 'channel:subscribe-change',
	}
};

export const CATEGORY = {
	INFRASTRUCTURE: 'infrastructure',
	CHANNEL: 'channel',
};
